import React from "react";
import { useFieldArray, Controller } from "react-hook-form";

import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TextField,
  Checkbox,
  Button,
  TableContainer,
  Paper,
} from "@material-ui/core";

const MAX = 5;

export default function LanguagesTable({ control }) {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "services",
    keyName: "fieldId",
  });

  const addRow = () => {
    if (fields.length < MAX) {
      append({
        id: fields.length + 1,
        language: "",
        dialect: "",
        telephone: false,
        video: false,
        onsite: false,
        translation: false,
        transcription: false,
      });
    }
  };

  return (
    <>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell>Languages *</TableCell>
              <TableCell>Dialects</TableCell>
              <TableCell>Services</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {fields.map((item, index) => (
              <TableRow key={item.fieldId}>
                <TableCell>{index + 1}</TableCell>

                {/* Language */}
                <TableCell>
                  <Controller
                    name={`services.${index}.language`}
                    control={control}
                    defaultValue={item.language || ""}
                    render={({ value, onChange }) => (
                      <TextField
                        value={value || ""}
                        onChange={onChange}
                        placeholder="Language"
                        variant="outlined"
                        size="small"
                        fullWidth
                      />
                    )}
                  />
                </TableCell>

                {/* Dialect */}
                <TableCell>
                  <Controller
                    name={`services.${index}.dialect`}
                    control={control}
                    defaultValue={item.dialect || ""}
                    render={({ value, onChange }) => (
                      <TextField
                        value={value || ""}
                        onChange={onChange}
                        placeholder="Dialect"
                        variant="outlined"
                        size="small"
                        fullWidth
                      />
                    )}
                  />
                </TableCell>

                {/* Services */}
                <TableCell>
                  <Controller
                    name={`services.${index}.telephone`}
                    control={control}
                    defaultValue={item.telephone || false}
                    render={({ value, onChange }) => (
                      <Checkbox
                        checked={!!value}
                        onChange={(e) => onChange(e.target.checked)}
                      />
                    )}
                  />
                  Telephone
                  <Controller
                    name={`services.${index}.video`}
                    control={control}
                    defaultValue={item.video || false}
                    render={({ value, onChange }) => (
                      <Checkbox
                        checked={!!value}
                        onChange={(e) => onChange(e.target.checked)}
                      />
                    )}
                  />
                  Video Call
                  <Controller
                    name={`services.${index}.onsite`}
                    control={control}
                    defaultValue={item.onsite || false}
                    render={({ value, onChange }) => (
                      <Checkbox
                        checked={!!value}
                        onChange={(e) => onChange(e.target.checked)}
                      />
                    )}
                  />
                  Onsite
                  <Controller
                    name={`services.${index}.translation`}
                    control={control}
                    defaultValue={item.translation || false}
                    render={({ value, onChange }) => (
                      <Checkbox
                        checked={!!value}
                        onChange={(e) => onChange(e.target.checked)}
                      />
                    )}
                  />
                  Translation
                  <Controller
                    name={`services.${index}.transcription`}
                    control={control}
                    defaultValue={item.transcription || false}
                    render={({ value, onChange }) => (
                      <Checkbox
                        checked={!!value}
                        onChange={(e) => onChange(e.target.checked)}
                      />
                    )}
                  />
                  Transcription
                </TableCell>

                {/* Remove */}
                <TableCell>
                  {fields.length > 1 && (
                    <Button size="small" onClick={() => remove(index)}>
                      X
                    </Button>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Button
        onClick={addRow}
        disabled={fields.length >= MAX}
        variant="contained"
        color="primary"
        size="small"
        style={{ marginTop: 10 }}
      >
        Add
      </Button>
    </>
  );
}
